<div
  class="flex flex-row gap-[8px] justify-center items-center w-full min-w-full h-full min-h-full"
>
  <span>{{ '+BOOKING.OVERVIEW.PACKAGES.NO_SEARCH_RESULTS' | translate }}</span>
  <strong>"{{ searchTerm }}"</strong>
</div>
